import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'azure-blob-storage',
  name: 'Azure Blob Storage',
  category: 'files',
  description: 'Store and manage files in Azure Blob Storage containers',
  icon: 'azure-blob-storage',
  iconType: 'microsoft-icon',
  color: 'cyan',
  version: '1.0.0',
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: false,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],
  credentials: [
    {
      name: 'azure_blob_storage',
      required: true,
      displayName: 'Azure Blob Storage Credentials',
    },
  ],
  subtitle: '={{ $parameter.resource }}: {{ $parameter.operation }}',
};

export default definition;
